import React, {
  useContext,
  createContext,
  useEffect,
  useState,
  useCallback
} from 'react';
import { COOKIES } from 'libs/constants';
import { useValidateUserSessionQuery } from 'store/api';
import Cookies from 'js-cookie';
import { store } from 'store';
import useInterval from './useInterval';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const AuthContext = createContext(undefined);
const defaultAuth: AuthStatus = {
  user: {
    id: '',
    isAdvisor: false,
    username: '',
    email: '',
    firstName: '',
    lastName: ''
  },
  isAuthenticated: false,
  loading: false,
  errors: null
};
export function AuthProvider({ children }) {
  const [sessionId, setSessionId] = useState(undefined);
  const {
    data: user,
    isLoading,
    error,
    refetch: refetchSession // refetch: to call the api again rather than returning the cached result from the redux store.
  } = useValidateUserSessionQuery('', {
    skip: !sessionId
  });

  const verifySession = useCallback(() => {
    const sessionCookie =
      (Cookies.get && Cookies.get(COOKIES.SessionId)) || null;
    if (sessionCookie !== sessionId) setSessionId(sessionCookie);
  }, [sessionId]);

  useInterval(() => {
    verifySession();
  }, 30000);

  useEffect(() => {
    verifySession();
  }, [verifySession]);

  useEffect(() => {
    if (user) refetchSession();
  }, [sessionId, refetchSession, user]);

  let auth;

  if (sessionId === undefined || isLoading)
    auth = { ...defaultAuth, isAuthenticated: undefined };
  else if (sessionId && !isLoading && !error && user) {
    auth = {
      user,
      isAuthenticated: true,
      loading: false
    };
  } else if (sessionId !== undefined && !isLoading)
    auth = { ...defaultAuth, isAuthenticated: false };
  else auth = { ...defaultAuth };
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}
export const AuthSession = () =>
  useContext<AuthStatus>(AuthContext) || defaultAuth;

export const AuthUserDetails = (): UserStatus => {
  const state = store.getState();
  let user = { ...defaultAuth.user };
  let storeUser;
  const sessionCookie = (Cookies.get && Cookies.get(COOKIES.SessionId)) || null;
  if (sessionCookie && state.api.queries['validateUserSession("")']) {
    storeUser = Object.assign(
      user,
      state.api.queries['validateUserSession("")'].data
    );
    user = storeUser as UserStatus;
  }
  return user;
};

// References: https://usehooks.com/useAuth/, https://hhpendleton.medium.com/useauth-265512bbde3c, https://docs.react2025.com/firebase/use-auth
